import { Assignment } from '@mui/icons-material'

import { Placeholder } from '@collaborate-health/uikit'
import { sessionTitleFormatter, trainingMaterialTitleFormatter } from '@tabeeb/modules/shared/utils/text'

export interface NoTrainingMaterialsAttachedPlaceholderProps {
  onAttach?: () => void
}

const NoTrainingMaterialsAttachedPlaceholder: React.FC<NoTrainingMaterialsAttachedPlaceholderProps> = ({
  onAttach,
}) => {
  return (
    <Placeholder
      icon={Assignment}
      title={trainingMaterialTitleFormatter.format('No training materials attached yet...')}
      subtitle={
        onAttach ? 'Click here to attach' : sessionTitleFormatter.format('Wait for session owner to attach them')
      }
      onClick={onAttach}
    />
  )
}

export default NoTrainingMaterialsAttachedPlaceholder

